import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTagCategorySector = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 18,
	viewBox: "0 0 19 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3029 13.8933C16.6472 12.6165 17.5127 9.6811 16.236 7.33676L11.9912 9.64844L14.3029 13.8933Z",
			stroke: "#1D1D1D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9381 6.1474L8.8053 8.94264L11.539 14.2843C8.62954 15.8687 4.98654 14.7946 3.40209 11.8852C1.81765 8.97575 2.89176 5.33274 5.80119 3.7483C8.71062 2.16386 12.3536 3.23797 13.9381 6.1474Z",
			stroke: "#1D1D1D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.93019 9.05827L4.87207 4.21484",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.82979 9.04929L7.25885 14.8294",
			stroke: "black"
		})
	]
});
export default SvgTagCategorySector;
